import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useSetRecoilState, useRecoilState } from "recoil";
import { refreshGlobal } from "../../../../atoms/refreshGlobal";
import TransferApiNovo from "../../../../services/transferApiNovo";
import { customColors } from "../../../../atoms/customColors";


export default function ModalDeleteConfirmation({
  isOpen,
  setIsOpen,
  getTransferList,
  id
}: any) {
  const finalRef = React.useRef(null);
  const navigate = useNavigate();
  const setRefreshGlobal = useSetRecoilState(refreshGlobal);
  const refresh = useRecoilState(refreshGlobal)[0];
  const colors = useRecoilState(customColors)[0];

  // const token = window.localStorage.getItem("token");
  // let jwtToken: JWTToken = jwt_decode(token || "");
  // const id = Number(jwtToken.idCliente);

  // const idTransfer = useRecoilState(selectedTransfer)[0];

  const onClose = () => {
    setIsOpen(false);
  };

  async function cancelSolicitation() {
    try {
      const response = await TransferApiNovo.deleteTransferPerId(id);
      toast.success("Solicitação Cancelada com Sucesso!");
      getTransferList();
      setRefreshGlobal(refresh + 1);
    } catch (error) {
      console.log("error:", error);
      toast.error("Não foi possível cancelar a solicitção!");
    }
  }

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader>
            <Flex w={"100%"} justifyContent={"center"}>
              <Text fontWeight={"bold"}>Deseja Cancelar a Transferência?</Text>
            </Flex>
          </ModalHeader>
          <ModalBody>
            {/* <Flex
              w={"530px"}
              alignItems={"flex-start"}
              minHeight={"250px"}
              height={"fit-content"}
              border={"2px solid #c4c4c4"}
              justifyContent={"space-evenly"}
              shadow={"md"}
              borderRadius={"6px"}
            ></Flex> */}
          </ModalBody>
          <ModalFooter justifyContent={"space-evenly"}>
            <Button background={colors.GRAY} color={"white"} mr={3} onClick={onClose}>
              Voltar
            </Button>
            <Button
              background={colors.REDMONEDD}
              color={"white"}
              mr={3}
              onClick={() => {
                cancelSolicitation();
                onClose();
              }}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
